import React from "react";
import { Plus, X } from "lucide-react";
import { PROGRAM_STATUS } from "@/admin/adminApi";
import { fieldInput, fieldLabel, btnGhost } from "@/admin/ui";

export const EMPTY_PROGRAM = {
  number: "", title: "", subtitle: "", descriptionText: "", heart_after_last: false, info: [], status: "draft",
};

export const toForm = (p) => ({ ...p, descriptionText: (p.description || []).join("\n\n") });

export const toPayload = (f) => ({
  number: f.number.trim(),
  title: f.title.trim(),
  subtitle: f.subtitle.trim(),
  description: f.descriptionText.split(/\n\s*\n/).map((t) => t.trim()).filter(Boolean),
  heart_after_last: f.heart_after_last,
  info: f.info.filter((r) => r.label.trim()).map((r) => ({ label: r.label.trim(), value: r.value })),
  status: f.status,
});

function InfoRows({ rows, onChange }) {
  const update = (i, key, val) => onChange(rows.map((r, j) => (j === i ? { ...r, [key]: val } : r)));
  return (
    <div>
      <p className={fieldLabel}>Programinformációk (a kártyán megjelenő adatsorok)</p>
      <div className="space-y-2.5">
        {rows.map((r, i) => (
          <div key={i} className="grid grid-cols-[1fr_2fr_auto] gap-2.5 items-start" data-testid={`program-info-row-${i}`}>
            <input value={r.label} onChange={(e) => update(i, "label", e.target.value)} placeholder="Megnevezés" data-testid={`program-info-label-${i}`} className={fieldInput} />
            <textarea rows={1} value={r.value} onChange={(e) => update(i, "value", e.target.value)} placeholder="Érték" data-testid={`program-info-value-${i}`} className={`${fieldInput} resize-y`} />
            <button type="button" aria-label="Sor törlése" onClick={() => onChange(rows.filter((_, j) => j !== i))} data-testid={`program-info-remove-${i}`} className="p-2.5 text-graphite-soft hover:text-[#9A3B2E]">
              <X className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
      <button type="button" onClick={() => onChange([...rows, { label: "", value: "" }])} data-testid="program-info-add" className={`${btnGhost} mt-3`}>
        <Plus className="w-3.5 h-3.5" /> Adatsor hozzáadása
      </button>
    </div>
  );
}

export default function ProgramForm({ form, setForm }) {
  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));
  return (
    <div className="space-y-6">
      <div className="grid md:grid-cols-[1fr_220px] gap-5">
        <div>
          <label className={fieldLabel} htmlFor="pf-number">Sorszám</label>
          <input id="pf-number" required value={form.number} onChange={set("number")} placeholder="pl. 3. Kiscsoportos alkalom" data-testid="program-form-number" className={fieldInput} />
        </div>
        <div>
          <label className={fieldLabel} htmlFor="pf-status">Megjelenítési állapot</label>
          <select id="pf-status" value={form.status} onChange={set("status")} data-testid="program-form-status" className={fieldInput}>
            {Object.entries(PROGRAM_STATUS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
          </select>
        </div>
      </div>
      <div>
        <label className={fieldLabel} htmlFor="pf-title">Cím</label>
        <input id="pf-title" required value={form.title} onChange={set("title")} data-testid="program-form-title" className={fieldInput} />
      </div>
      <div>
        <label className={fieldLabel} htmlFor="pf-subtitle">Alcím</label>
        <input id="pf-subtitle" value={form.subtitle} onChange={set("subtitle")} data-testid="program-form-subtitle" className={fieldInput} />
      </div>
      <div>
        <label className={fieldLabel} htmlFor="pf-desc">Leírás — a bekezdéseket üres sorral válaszd el</label>
        <textarea id="pf-desc" rows={10} value={form.descriptionText} onChange={set("descriptionText")} data-testid="program-form-description" className={`${fieldInput} leading-[1.7] resize-y`} />
      </div>
      <label className="flex items-center gap-3 cursor-pointer font-body text-[14px] text-graphite" data-testid="program-form-heart">
        <input type="checkbox" checked={form.heart_after_last} onChange={set("heart_after_last")} className="accent-gold" />
        Arany szív ikon az utolsó bekezdés végén
      </label>
      <InfoRows rows={form.info} onChange={(info) => setForm((f) => ({ ...f, info }))} />
    </div>
  );
}
